import { QueryFunctionContext } from '@tanstack/react-query';
import axios from 'src/libs/axios';

const getCustomerInfo = (args: QueryFunctionContext<any>) => {
  const [url] = args.queryKey;

  return axios({
    method: 'get',
    url,
  });
};

const updatePolicyCheck = (url: string) => {
  return axios({
    method: 'put',
    url,
  });
};

export default {
  updatePolicyCheck,
  getCustomerInfo,
};
